import {LearnerActivity} from './LearnerActivity';
import {LearnerActivityType} from './LearnerActivityType';

export class LearnerCourseActivity extends LearnerActivity {
  public readonly lessonId?: string;

  constructor(
    verb: string,
    object: string,
    lessonId?: string,
  ) {
    super(LearnerActivityType.COURSE, verb, object);
    this.lessonId = lessonId;
  }
}
